<template>
  <div class="companyInfo">
    <div class="form-item">
      <label class="label"><i class="required">*</i>企业账号</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.userName" type="text" placeholder="企业账号">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>密码</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.password" autocomplete="off" type="password" placeholder="密码" @blur="checkPassword">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>再次输入密码</label>
      <div class="input-box">
        <input class="input" v-model.trim="password" autocomplete="off" type="password" placeholder="再次输入密码" @blur="checkPassword">
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>联系人</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.LinkMan" type="text" placeholder="联系人">
      </div>
    </div>
    <div class="form-item">
      <label class="label">联系人职位</label>
      <div class="input-box">
        <el-select v-model="form.LinkManPost" value-key="CodeValue" placeholder="联系人职位">
          <el-option v-for="item in station" :key="item.CodeValue" :value="item.CodeValue" :label="item.CodeName1"></el-option>
        </el-select>
      </div>
    </div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>手机号</label>
      <div class="input-box">
        <input class="input" v-model.trim="form.linkPhone" type="text" placeholder="联系人手机号">
      </div>
    </div>
    <div id="captcha"></div>
    <div class="form-item">
      <label class="label"><i class="required">*</i>验证码</label>
      <div class="input-box">
        <input class="input code-input" v-model.trim="form.validateCode" type="text" placeholder="手机验证码">
        <button class="btn-code" :disabled="btnDisabled" @click="getCode">{{codeBtnText}}</button>
      </div>
    </div>
    <div class="form-item" v-if="type==0">
      <label class="label"></label>
      <div class="input-box">
        <el-checkbox v-model="form.isAgree" class="agree-deal" :true-label="1" :false-label="0">
          <span class="agree">我已阅读并同意</span>
          <a class="deal" target="_blank" href="/Help/helpCenter_09.html">《工业速派使用协议》、</a>
          <a class="deal" target="_blank" href="/Help/helpCenter_12.html">《工业速派隐私权条款》</a>
        </el-checkbox>
      </div>
    </div>
    <div class="form-item">
      <span class="label"></span>
      <div class="input-box">
        <button class="btn-default" @click="prevStep">上一步</button>
        <button class="btn-primary" @click="submit">{{type==0?'提交':'下一步'}}</button>
      </div>
    </div>
  </div>
</template>
<script>
import {p_origin} from '@/scripts/util.js'
import Bus from '@/scripts/bus.js'
import Cookie from 'js-cookie'
import validate from '@/scripts/validate.js'
import {
  CompanyRegister,
  CompanyLogin,
  GetAccountData,
  GetAccountType,
  SendMobileCode,
  CodeLines,
} from '@/scripts/api.js';
let _dx=window._dx;
export default {
  data(){
    return{
      form:{
        userName:'',
        password:'',
        LinkMan:'',
        linkPhone:'',
        LinkManPost:'',
        validateCode:'',
        isAgree:0,
      },
      password:'',
      codeBtnText: "获取验证码",
      btnDisabled: false,
      timer: null,
      imgCodeToken:'',
      authData:null,
      station:[],//联系人职位
    }
  },
  props:['type'],//0:普通企业，1:服务站
  created() {
    this.pageInit();
  },
  mounted() {
    // let myCaptcha = _dx.Captcha(document.getElementById('captcha'), {
    //     appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
    //     style: 'inline',
    //     inlineFloatPosition: 'down',
    //     success: function (token) {
    //         console.log(token)
    //     }
    // })
    Bus.$on('toCompanyRegister2',data=>{
      this.authData=data;
    });
  },
  methods: {
    pageInit(){
      CodeLines({
        CodeName:'LinkManPost',
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          this.station=r.Data.Lines || [];
        }
      })
    },
    //上一步
    prevStep(){
      this.$emit('stepChange',0);
    },
    checkPassword() {
      if (this.form.password == "") {
        return;
      }
      if (this.password == "") {
        return;
      }
      if(!validate.password(this.form.password)){
        this.$toast('密码为6-14位数字字母组合');
        return;
      }
      if (this.password != this.form.password) {
        this.$toast("密码不一致，请重新输入！");
        this.password = "";
        return;
      }
    },
    //获取验证码
    getCode() {
      var self = this;
      if (this.form.linkPhone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.form.linkPhone !== "" &&
        !validate.phone(this.form.linkPhone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      var myCaptcha = _dx.Captcha(document.getElementById('captcha'), {
          appId: 'e8941fd8bdcac157c64dedb50d13d1f7', //appId，在控制台中“应用管理”或“应用配置”模块获取
          style: 'inline',
          success: function (token) {
            SendMobileCode({
              phone: self.form.linkPhone,
              codeType:105,
              imgCodeToken:token,
              platform:'pcweb',
            }).then(r => {
              // myCaptcha.hide();
              if (r.Result == 1) {
                let time = 60;
                self.btnDisabled = true;
                self.timer = setInterval(() => {
                  time--;
                  self.codeBtnText = time + "s";
                  if (time <= 0) {
                    time = 60;
                    self.btnDisabled = false;
                    self.codeBtnText = "获取验证码";
                    clearInterval(self.timer);
                  }
                }, 1000);
                self.$toast(r.Message);
              } else {
                self.$toast(r.Message);
              }
            });
          },
          fail:function(err){
            console.log(err)
          }
      })
      myCaptcha.show();
    },
    //提交
    submit() {
      let params = this.authData;
      if (!this.authData) {
        this.$toast("第一步保存失效，请重新输入！");
        this.prevStep();
      }
      if(!this.form.userName){
        this.$toast('请输入企业账号！');
        return;
      }
      if(!validate.password(this.form.password)){
        this.$toast('密码为6-20位数字字母组合');
        return;
      }
      if (this.password != this.form.password) {
        this.$toast("密码不一致，请重新输入！");
        return;
      }
      if (this.form.LinkMan === "") {
        this.$toast("请输入联系人姓名！");
        return;
      }
      if (this.form.linkPhone === "") {
        this.$toast("请输入手机号！");
        return;
      }
      if (
        this.form.linkPhone !== "" &&
        !validate.phone(this.form.linkPhone)
      ) {
        this.$toast("手机号格式不正确");
        return;
      }
      if (this.form.validateCode === "") {
        this.$toast("请输入手机验证码！");
        return;
      }
      if (!this.form.isAgree && this.type==0) {
        this.$toast('请阅读并同意工业速派使用协议,工业速派隐私权条款');
        return;
      }
      // let aseKey = "48c1f0c2cea944e19257c50fd770be87";
      // let obj = {
      //   AppId:101001,
      //   ...params,
      //   ...this.form
      // };
      let obj = {
        AppId: 101001,
        userName: this.form.userName,        //企业登录账号
        password: this.form.password,
        linkPhone: this.form.linkPhone,
        LinkManPost:this.form.LinkManPost ||0,
        validateCode: this.form.validateCode,
        isAgree: 1,
        LinkMan: this.form.LinkMan,
        businessLicense: params.BusinessLicenseImgPath,
        companyName: params.CompanyName,         //企业名称
        EnterpriseLicenseNumber: params.BusinessLicense,
        BusLicenseCompanyType: params.BusLicenseCompanyType,
        TianWeiYunCompanyType: params.TianWeiYunCompanyType,
        RegisteredCapital: params.RegisteredCapital,
        EstablishmentDate: params.EstablishmentDate,
        BusinessTerm: params.BusinessTerm,
        RegisterAddress: params.RegisterAddress,
        LegalPerson: params.LegalPerson,
        IsRegisterServiceStation:this.type==1?true:false,
        platform:'pcweb',
      }
      if(this.type==0){
        obj['isAgree']=1;
      }
      CompanyRegister(obj).then(r => {
        if(r.Result==1){
          this.$toast(r.Message);
          if(this.type==1){
            this.$emit('stepChange',2);
            Bus.$emit('toRegService',r.Data);
          }else{
            this.login();
          }
        }else{
          this.$toast(r.Message);
        }
      });
    },
    login(){
      CompanyLogin({
        loginName:this.form.userName,
        password:this.form.password,
        AppId:101001,
        platform:'pcweb',
      }).then(r=>{
        if(r.Result==1){
          let data=r.Data;
          let index=p_origin.indexOf('.');
          let domain=p_origin.substr(index+1);
          Cookie.set('CompanyIsLogin', 'true', {domain:domain, expires: 7, path: '/' });
          Cookie.set('KCompanyName', data.companyName, {domain:domain, expires: 7, path: '/' });
          Cookie.set('KCompanyid', data.companyId, {domain:domain, expires: 7, path: '/' });
          window.location.href=p_origin;
          this.$toast(r.Message);
        }else{
          this.$toast(r.Message);
        }
      })
    }
  },
}
</script>
<style lang="scss">
.companyInfo{
  #captcha{
    margin-left: 120px;
    position: relative;
    z-index: 10;
    margin-bottom: 20px;
  }
  .el-select{
    width: 100%;
  }
}
</style>